import React from 'react'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import CommonBtn from './CommonBtn'
import { EVENT_TYPES, EVENT_LOG_TITLE, EMPTY_OBJECT } from '../../constants/globalConstants'
import { dateFormatter } from '../../utils/helper'
import { addEventLog } from '../../redux/actions/EventsLog'
import { downloadPassQrcodeRequest, downloadQrcodeRequest } from '../../redux/actions/booking'
import { useState } from 'react'
import { globalKeyStore } from '../../redux/actions/globalState'

const BookingAlert = ({ type, heading, message, dispatch, paymentResponse, selectedFacilityId }) => {
    const [promoLoader, setPromoLoader] = useState(false)
    const getCard = (e, ID) => {
        setPromoLoader(true)
        const eventType = localStorage.getItem('selectEventType')
        const event_data = JSON.parse(localStorage.getItem('event_data'))
        const personal_info = JSON.parse(localStorage.getItem('personal_info'))
        const sessionDetails = JSON.parse(localStorage.getItem('sessionDetails'))
        const pdfName = `${eventType}-${dateFormatter(event_data?.start_date, 'MM-DD-YYYY')}`
        // const pdfName = eventType == EVENT_TYPES?.EVENT ? `${eventDetails?.event_category_event?.event_category?.name}-${dateFormatter(eventDetails?.start_time,'MM-DD-YYYY')}` : `${eventDetails?.description}-${dateFormatter(eventDetails?.start_date,'MM-DD-YYYY')}`
        const selLocalFacilityId = JSON.parse(localStorage?.getItem('selectedFacilityId'))
        if (selLocalFacilityId || selectedFacilityId) {
            const eventFacilityid = (selLocalFacilityId) ? selLocalFacilityId : selectedFacilityId
            dispatch(globalKeyStore({ selectedFacilityId: eventFacilityid }))

            const postData = {
                'facility_id': eventFacilityid,
                'name': personal_info?.name,
                'phone': personal_info?.phone,
                'email': personal_info?.email,
                // 'total' : (coupon == 'NIL' || coupon == '') ? paymentSession?.amount + paymentSession?.tax_rate : paymentSession?.amount,
                'total': sessionDetails?.amount,
                'rate_id': eventType !== EVENT_TYPES?.BUNDLE_PASS ? event_data?.id : '',
                'event_id': eventType == EVENT_TYPES?.EVENT ? event_data?.id : '',
                'event_ids': '', //eventType !== EVENT_TYPES?.EVENT && eventType !== EVENT_TYPES?.PARTY_PASS ? userEvents?.split(',') : '',
                'event_category_id': event_data?.event_category?.id,
                'event': event_data,
                'arrival': eventType == EVENT_TYPES?.EVENT ? event_data?.start_time : event_data?.all_event[0]?.start_time,
            }
            const payload = {
                'error_message': JSON.stringify(postData),
                'user_ip': 'NA',
                'facility_id': eventFacilityid
            }
            dispatch(addEventLog(payload, EVENT_LOG_TITLE?.DOWNLOAD_TICKET))
            if(paymentResponse?.event_type === 'simple-pass') {
                dispatch(downloadPassQrcodeRequest(ID, pdfName, setPromoLoader))
            } else {
                dispatch(downloadQrcodeRequest(ID, pdfName, setPromoLoader))
            }
        }
    }
    return (
        <div>
            <div className={`alert ${type === 'success' ? 'alert-success' : type === 'error' ? 'alert-danger' : 'alert-warning'}`} role="alert">
                <div className="row g-0 align-items-center">
                    {type === 'success' && <div className="col-auto">
                        <i className="fa fa-check-circle fa-4x me-3" aria-hidden="true"></i>
                    </div>}
                    {type === 'error' && <div className="col-auto">
                        <i className="fa fa-times fa-4x me-3" aria-hidden="true"></i>
                    </div>}
                    <div className="col-8 col-sm">
                        <h3 className="mb-0">{heading}</h3>
                        <p className="m-0">{message}</p>
                    </div>
                    <div className="col-sm-auto text-center">
                        {type === 'success' && <div className="d-flex align-items-center">
                            <CommonBtn
                                isIconBtn
                                className="btn btn-success w-100"
                                icon={<i className="fa fa-download me-2" aria-hidden="true"></i>}
                                onClick={(e) => getCard(
                                    e,
                                    paymentResponse?.id
                                )}
                                loadingIcon={promoLoader}
                                disabled={promoLoader ? 'disabled' : null}
                                textRight='Download Ticket'
                            />
                            {/* <CommonBtn isIconBtn className="btn btn-dark ms-2" icon={<i className="fa fa-info-circle" aria-hidden="true"></i>} /> */}
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    )
}

BookingAlert.propTypes = {
    dispatch: PropTypes.func,
    type: PropTypes.string,
    heading: PropTypes.string,
    message: PropTypes.string,
    paymentResponse: PropTypes.object,
    selectedFacilityId: PropTypes.string
}

BookingAlert.defaulProps = {
    dispatch: noop,
    type: 'success',
    heading: 'Heading',
    message: 'Message',
    paymentResponse: EMPTY_OBJECT,
    selectedFacilityId: ''
}

function mapStateToProps({ globalReducers }) {
    return {
        passData: globalReducers?.passData,
        selectEventType: globalReducers?.selectEventType,
        sessionDetails: globalReducers?.sessionDetails,
        selectedFacilityId: globalReducers?.selectedFacilityId
    }
}

export default connect(mapStateToProps)(BookingAlert)
